import React, { useEffect, useRef, useState } from "react"
import "./Categorytable.scss"
import CategoryApi from "Api/CategoryApi"
import { useNavigate } from "react-router-dom"
import {
  Button,
  Col,
  Input,
  Pagination,
  PaginationItem,
  PaginationLink,
  Row,
  Spinner,
  Table,
} from "reactstrap"
import CustomBreadCrumb from "utils/CustomBreadCrumb/CustomBreadCrumb"
import DataTableLoader from "SkeletonLoader/DataTableLoader"
import { Toast } from 'primereact/toast'

const Categorytable = () => {
  document.title = "Category"

  const accessToken = localStorage.getItem("accessToken")
  const [catgeoryDetails, setCategoryDetails] = useState([])
  const [page, setPage] = useState(1)
  const [totalRecords, setTotalRecords] = useState(0)
  const [limit, setLimit] = useState(10)
  const navigate = useNavigate("")
  const userData = JSON.parse(localStorage.getItem("userData"))
  const [loading, setLoading] = useState(true)
  const [addCategoryLoader, setAddCategoryLoader] = useState(false)
  const [filteredCategoryDetails,setFilteredCategoryDetails]=useState([]);
  const [filterStatus, setFilterStatus] = useState("all");
  const toast = useRef(null);


  const getAllCategoryDetails = () => {
    const config = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      params: {
        limit: limit,
        page: page,
      },
    }

    CategoryApi.getAllCategory(config)
      .then(response => {
        if (response.data.status) {
          setLoading(false)
          setCategoryDetails(response.data.data)
          setTotalRecords(response.data.totalRecords)
        }
      })
      .catch(error => {
        console.log("Error Fetching course", error)
      })
  }
  useEffect(() => {
    getAllCategoryDetails()
  }, [accessToken, page, limit])

   useEffect(() => {
      if (filterStatus === "all") {
        setFilteredCategoryDetails(catgeoryDetails);
      } else {
        const filteredData = catgeoryDetails.filter(
          (category) => category.verifiedStatus === filterStatus
        );
        setFilteredCategoryDetails(filteredData);
      }
    }, [filterStatus, catgeoryDetails]);

  const breadcrumbItems = [
    { label: "Pixwik", link: "#" },
    { label: "Category", link: "#" },
    { label: "Category List", link: "#" },
  ]

  const totalPages = Math.ceil(totalRecords / limit)

  const uploadbtn = useRef()

  const handleUploadButtonClick = () => {
    uploadbtn.current.click()
  }
  const [excelLoader, setExcelLoader] = useState(false)

  const handleFileChange = event => {
    const file = event.target.files[0]
    if (!file) return
    const formData = new FormData()
    formData.append("file", file)

    const config = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }
    setExcelLoader(true)

    CategoryApi.uploadCategoryByExcel(formData, config)
      .then(res => {
        getAllCategoryDetails()
        event.target.value = ""
        setExcelLoader(false)
        toast.current.show({severity:'success', summary: 'Success', detail: res.data.message, life: 3000});
      })
      .catch(err => {
        console.log(err)
        event.target.value = ""
        setExcelLoader(false)
          toast.current.show({severity:'error', summary: 'Error', detail: err.response.data.message, life: 3000});
      })
  }
  const handleAddCategoryClick = () => {
    setAddCategoryLoader(true)
    setTimeout(() => {
      setAddCategoryLoader(false)
      navigate("/add-category")
    }, 500)
  }
  return (
    <>
    <Toast ref={toast} />
      <Row>
        <Col xs="12">
          <div className="category-list-header d-flex  align-items-center justify-content-between">
            <CustomBreadCrumb data={breadcrumbItems} pageTitle="Category" />
            <div className="d-flex align-items-center gap-3">

            <Input
                type="select"
                value={filterStatus}
                onChange={(e) => setFilterStatus(e.target.value)}
                style={{ width: "150px" }}
              >
                <option value="all">All</option>
                <option value="approve">Approved</option>
                <option value="reject">Rejected</option>
                <option value="pending">Pending</option>
              </Input>
              <input
                type="file"
                ref={uploadbtn}
                style={{ display: "none" }}
                onChange={handleFileChange}
              />
              <Button
                type="button"
                color="success"
                className="waves-effect"
                onClick={handleUploadButtonClick}
              >
                {excelLoader ? (
                  <Spinner size="sm" />
                ) : (
                  <i className="mdi mdi-microsoft-excel" />
                )}
              </Button>

              <Button
                type="button"
                color="secondary"
                className="waves-effect"
                onClick={handleAddCategoryClick}
              >
                {/* {addCategoryLoader ? (
                  <Spinner size="sm"/>
                ):("Add Catgeory")} */}
                Add Catgeory
              </Button>
            </div>
          </div>

          <div className="category-data-table table-responsive mt-4 mb-3 ">
            {loading ? (
              <DataTableLoader cols={10} />
            ) : (
              <Table className="table mb-0">
                <thead className="table-light">
                  <tr>
                    <th>#</th>
                    <th>Category Name</th>
                    <th>Verified Status</th>
                    <th>Edit</th>
                    <th>View</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredCategoryDetails.map((category, index) => (
                    <tr key={category._id} className="university-table-row">
                      <th scope="row">{(page - 1) * limit + index + 1}</th>
                      <td>{category.categoryName}</td>

                      <td>
                        <span
                          className={`status ${category.verifiedStatus.toLowerCase()}`}
                        >
                          {category.verifiedStatus === "approve"
                            ? "Approved"
                            : category.verifiedStatus === "reject"
                              ? "Rejected"
                              : "Pending"}
                        </span>
                      </td>

                      {category.verifiedStatus === "pending" ||
                      (["approve", "reject"].includes(
                        category.verifiedStatus,
                      ) &&
                        userData?.role === "manager") ? (
                        <td>
                          <span
                            className="edit-course"
                            onClick={() => {
                              navigate(
                                `/edit-category/${category?.categoryCode}`,
                                {
                                  state: category,
                                },
                              )
                            }}
                          >
                            <i className="ion ion-md-create" />
                          </span>
                        </td>
                      ) : (
                        <td>
                          <span className="edit-course no-access">
                            <i className="fas fa-ban" />
                          </span>
                        </td>
                      )}

                      <td>
                        <span
                          onClick={() => {
                            navigate(`/view-category/${category?.categoryCode}`)
                          }}
                          className="view-course"
                        >
                          <i className="ion ion-md-eye" />
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            )}
          </div>
          <div className="pagination-container d-flex align-items-center justify-content-end">
            <Pagination>
              <PaginationItem disabled={page <= 1}>
                <PaginationLink previous onClick={() => setPage(page - 1)} />
              </PaginationItem>
              {[...Array(totalPages)].map((_, index) => (
                <PaginationItem key={index} active={index + 1 === page}>
                  <PaginationLink onClick={() => setPage(index + 1)}>
                    {index + 1}
                  </PaginationLink>
                </PaginationItem>
              ))}

              <PaginationItem disabled={page >= totalPages}>
                <PaginationLink next onClick={() => setPage(page + 1)} />
              </PaginationItem>
            </Pagination>
          </div>
        </Col>
      </Row>
    </>
  )
}

export default Categorytable
